import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromTag from './reducers/tag.reducer';
import { EffectsModule } from '@ngrx/effects';
import { TagEffects } from './effects/tag.effects';
import { TagService } from './services/tag.service';
import { GroupTagService } from './services/group-tag.service';
import { TagStoreFacade } from './facades/tag-store.facade';
import { GroupTagStoreFacade } from './facades/group-tag-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromTag.tagFeatureKey, fromTag.reducer),
    EffectsModule.forFeature(TagEffects),
  ],
  providers: [
    TagService,
    TagStoreFacade,
    GroupTagService,
    GroupTagStoreFacade,
  ],
})
export class TagStoreModule {}
